module.exports = __webpack_public_path__ + "media/images/buttercms/small-logo-blog-e8189ad68c79c82ea7a191de5bbac93b.svg";